import dayjs from 'dayjs';
import { useOrderAPI } from '../../apis/order-api';
import { usePaymentAPI } from '../../apis/payment-api';
import { usePaymentPixAPI } from '../../apis/payment-pix-api';
import { useStorage } from '../../hooks/use-storage';

function usePaymentPixManager() {
  const { loadPaymentFromRemote } = usePaymentAPI();
  const {
    generatePaymentPixFromRemote,
    cancelPaymentPixFromRemote,
    refreshPaymentPixStatusFromRemote,
  } = usePaymentPixAPI();
  const { findSpotOrdersFromRemote } = useOrderAPI();
  const { setPayment, setOrders } = useStorage();

  async function generateAndStorePaymentPix({ orders, tipAmount }) {
    const response = await generatePaymentPixFromRemote(
      orders?.map((order) => order.id),
      tipAmount
    );

    await updatePaymentPix(response, orders);
  }

  async function refreshPaymentPix({ payment, orders }) {
    if (payment.pix?.id == null) return;
    let response;

    try {
      response = await refreshPaymentPixStatusFromRemote(payment.pix.id);
    } catch (error) {
      if (error.response?.status === 409) {
        response = null;
      } else if (error.response?.status === 404) {
        setPayment(null);
      } else {
        throw error;
      }
    }

    if (response != null) {
      await updatePaymentPix(response, orders);
    }

    // const orderResponse = await findSpotOrdersFromRemote();
    // setOrders(orderResponse.data);

    // let response;

    // try {
    //   response = await refreshPaymentCardStatusFromRemote(payment.card.id);
    // } catch (error) {
    //   if (error.response?.status === 409) {
    //     response = null;
    //   } else {
    //     throw error;
    //   }
    // }

    // if (response != null) {
    //   await updatePaymentCard(response, orders);
    // }
  }

  async function updatePaymentPix(response, orders) {
    const paymentResponse = await loadPaymentFromRemote(
      response.data.payment.id
    );

    const payment = paymentResponse.data;
    payment.pix = response.data;
    payment.local_time = dayjs().toISOString();
    payment.orders = payment.orders.map((order) =>
      orders.find((o) => o.id === order.id)
    );

    delete payment.pix.payment;
    setPayment(payment);

    const orderResponse = await findSpotOrdersFromRemote();
    setOrders(orderResponse.data);
  }

  async function cancelPaymentPix(payment) {
    if (payment.pix?.id == null) return;
    let count = 0;
    let repeat;

    do {
      repeat = false;

      try {
        // eslint-disable-next-line no-await-in-loop
        await cancelPaymentPixFromRemote(payment.pix.id);
        setPayment(null);
      } catch (error) {
        if (error.response?.status === 409) {
          if (count < 3) {
            repeat = true;
            count += 1;
          }
        } else if (
          error.response?.status !== 422 ||
          error.response?.data?.find((v) => v.code === 8) == null
        ) {
          throw error;
        }
      }
    } while (repeat);

    const response = await findSpotOrdersFromRemote();
    setOrders(response.data);
  }

  return {
    generateAndStorePaymentPix,
    refreshPaymentPix,
    cancelPaymentPix,
  };
}

export { usePaymentPixManager };
